export {
  STOCK_MOVEMENT_REASONS,
  getStockMovementReasonLabel,
  extractSaleIdFromStockMovement,
  extractWorkOrderIdFromStockMovement,
  isSaleStockMovementReason,
  REASONS_ALLOWING_NEGATIVE_STOCK,
  reasonAllowsNegativeStock,
  type StockMovementReasonKey,
} from '../../../shared/domain/stockMovementReasons';
